import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Container, Typography } from '@mui/material';

import AppStore from '../../assets/images/appstore.png';
import GooglePlay from '../../assets/images/googleplay.png';
import HeroBgBottomLeft from '../../assets/images/heroBg.webp';
import LogoIcon from '../../assets/landing/new_logo.png';
import DownloadIcon from '../../assets/icons/Download, Save, Upload.png';

import CustomButton from '../CustomButton';

import styles from './AuthWrapper.module.scss';

type AuthWrapperProps = {
  btnName: 'Sign Up' | 'Sign In';
  children: React.ReactNode;
};

const AuthWrapper: FC<AuthWrapperProps> = ({ children, btnName }) => {
  const navigate = useNavigate();

  return (
    <Box className={styles.authContainerWrapper}>
      <Box className={styles.authHeader}>
        <Box
          className={styles.logoContainer}
          onClick={() => navigate('/')}
        >
          <Typography variant="h6Bold">Trav</Typography>
          <img
            src={LogoIcon}
            className={styles.logo}
            alt="logo"
          />
          <Typography variant="h6Bold">Genius</Typography>
        </Box>
        <CustomButton
          variant="outlined"
          onClick={() => navigate('/sign-in')}
          customClass={styles.downloadContainer}
        >
          <Box className={styles.downloadContentWrapper}>
            <Typography variant="h10Bold">App</Typography>
            <img
              className={styles.downloadIcon}
              src={DownloadIcon}
              alt="logo"
            />
          </Box>
        </CustomButton>
      </Box>

      <Container
        maxWidth={false}
        sx={{ padding: '0 !important' }}
      >
        <Box className={styles.authContent}>
          <Box className={styles.authContentLeft}>
            <img
              fetchPriority="high"
              src={HeroBgBottomLeft}
              className={styles.imageBottomLeft}
              alt="bottom-left-bg"
            />
            <Box className={styles.contentWrapper}>
              <Box className={styles.authContentLeftText}>
                <Box
                  flexWrap="nowrap"
                  display="flex"
                  gap={1}
                >
                  <Typography sx={{ fontSize: '40px', lineHeight: '50px', fontWeight: 'bold', color: '#222B3A' }}>
                    Your{' '}
                  </Typography>
                  <Typography
                    sx={{ fontSize: '40px', fontWeight: 'bold', lineHeight: '50px' }}
                    className={styles.gradientText}
                  >
                    AI-powered
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    textAlign: 'center',
                    lineHeight: '50px',
                    fontSize: '40px',
                    fontWeight: 'bold',
                    color: '#222B3A',
                  }}
                >
                  travel planner in one app
                </Typography>
              </Box>
              <Box className={styles.downloadBtns}>
                <Link
                  to="https://www.apple.com/app-store/"
                  target="_blank"
                >
                  <img
                    src={AppStore}
                    alt="Download on the App Store"
                    style={{ width: '150px' }}
                  />
                </Link>
                <Link
                  to="https://play.google.com/store"
                  target="_blank"
                >
                  <img
                    src={GooglePlay}
                    alt="Download on the App Store"
                    style={{ width: '150px' }}
                  />
                </Link>
              </Box>
            </Box>
          </Box>
          <Box className={styles.authContentRight}>{children}</Box>
        </Box>
      </Container>
    </Box>
  );
};

export default AuthWrapper;
